import { ADO } from 'actions/ado'
import { SET_EXPERIMENTS } from 'actions/experiments'

export default (state = null, action) => {
    switch (action.type) {
        case ADO:
            if (!!action.error) {
                return action.payload
            } else {
                return action.payload.data;
            }
        case SET_EXPERIMENTS:
            return Object.assign({}, state, action.payload.data);
    }

    return state;
}
